// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mention__container-def3f6 {
  max-width: var(--max-width-input-top-panel);
  min-width: var(--message-bubble-min-width);
  width: 100%;
  margin: 0 auto;
}

.Mention__info-card-dae762 {
  margin: 0 14px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/MentionList/Mention/styles.m.css"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,0CAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".container {\n  max-width: var(--max-width-input-top-panel);\n  min-width: var(--message-bubble-min-width);\n  width: 100%;\n  margin: 0 auto;\n}\n\n.info-card {\n  margin: 0 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Mention__container-def3f6`,
	"info-card": `Mention__info-card-dae762`,
	"infoCard": `Mention__info-card-dae762`
};
module.exports = ___CSS_LOADER_EXPORT___;
